import { Component, EventEmitter, OnDestroy, OnInit, Output, inject, signal } from "@angular/core"
import { FormControl, FormGroup, Validators } from "@angular/forms"
import { BillingDataService } from "src/app/services/billing-data.service"
import { IbanValidator } from "src/app/tools/iban.validator"

@Component({
  selector: "ow-banking-account-form",
  templateUrl: "./banking-account-form.component.html"
})
export class BankingAccountFormComponent implements OnDestroy, OnInit {

  @Output() updateValidity = new EventEmitter<boolean>(false)
  
  private readonly billingDataService = inject(BillingDataService)

  public readonly form = new FormGroup({
    inherit: new FormControl<boolean>(this.billingDataService.getBankingAccount().inherit),
    firstName: new FormControl<string>(this.billingDataService.getBankingAccount().firstName),
    lastName: new FormControl<string>(this.billingDataService.getBankingAccount().lastName),
    iban: new FormControl<string>(this.billingDataService.getBankingAccount().iban, [
      Validators.required,
      IbanValidator
    ]),
    bic: new FormControl<string>(this.billingDataService.getBankingAccount().bic, [Validators.required, Validators.pattern(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/)]),
    authorize: new FormControl<boolean>(this.billingDataService.getBankingAccount().authorize, [Validators.requiredTrue]),
    creditInstitution: new FormControl<string>(this.billingDataService.getBankingAccount().creditInstitution, [Validators.required, Validators.maxLength(50)])
  })

  public readonly showContactFields = signal<boolean>(false)

  private readonly subscriptions = [
    this.form.controls.inherit.valueChanges.subscribe((value) => {
      this.onInheritChange()
      if (this.form.controls.inherit.valid) {
        this.billingDataService.setBankingAccount({ inherit: value! })
      }
    }),
    this.form.controls.firstName.valueChanges.subscribe((value) => {
      if (this.form.controls.firstName.valid) {
        this.billingDataService.setBankingAccount({ firstName: value! })
      }
    }),
    this.form.controls.lastName.valueChanges.subscribe((value) => {
      if (this.form.controls.lastName.valid) {
        this.billingDataService.setBankingAccount({ lastName: value! })
      }
    }),
    this.form.controls.iban.valueChanges.subscribe((value) => {
      if (this.form.controls.iban.valid) {
        this.billingDataService.setBankingAccount({ iban: value! })
      }
    }),
    this.form.controls.bic.valueChanges.subscribe((value) => {
      if (this.form.controls.bic.valid) {
        this.billingDataService.setBankingAccount({ bic: value! })
      }
    }),
    this.form.controls.creditInstitution.valueChanges.subscribe((value) => {
      if (this.form.controls.creditInstitution.valid) {
        this.billingDataService.setBankingAccount({ creditInstitution: value! })
      }
    }),
    this.form.controls.authorize.valueChanges.subscribe((value) => {
      if (this.form.controls.authorize.valid) {
        this.billingDataService.setBankingAccount({ authorize: value! })
      }
    }),
    this.form.statusChanges.subscribe(() => {
      this.updateValidity.emit(this.form.valid)
    })
  ]

  ngOnInit(): void {
    this.onInheritChange()
    this.updateValidity.emit(this.form.valid)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

  private onInheritChange(): void {
    this.showContactFields.set(!this.form.controls.inherit.value)
    if (this.form.controls.inherit.value) {
      this.form.controls.firstName.clearValidators()
      this.form.controls.lastName.clearValidators()
    } else {
      this.form.controls.firstName.addValidators([Validators.required, Validators.maxLength(24)])
      this.form.controls.lastName.addValidators([Validators.required, Validators.maxLength(24)])
    }
    this.form.controls.firstName.updateValueAndValidity()
    this.form.controls.lastName.updateValueAndValidity()
  }
}
